import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camera-qiangji",
  "use": "icon-camera-qiangji-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-camera-qiangji\"><path fill=\"#0000FF\" d=\"M245.834901 705.404389H122.91745v-153.814002L0 528.91954v494.879833l122.91745-40.125392v-170.198537h198.955068l105.329154-142.244514-140.438872-73.964472-40.927899 108.071055z m637.793103 28.489028l286.762801-176.351097L280.944619 0.066876H175.548589l-140.438871 210.45768v74.098224l784.117032 454.75444z m-105.329153 39.791014L105.329154 352.702194 35.109718 426.666667l784.117032 455.155695H889.446186l35.109718-34.173459 35.109718-102.453501-105.329154 73.964473c-46.812957-34.106583-76.037618-45.54232-76.037617-45.54232z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/camera-qiangji.svg
// module id = tq7O
// module chunks = 197